import { enumToEnumNames } from '../../common-client2/src/services/enums';

const LESS = 'less';
const EQUAL_OR_LESS = 'equalOrLess';
const EQUAL = 'equal';
const EQUAL_OR_MORE = 'equalOrMore';
const MORE = 'more';

export const BreakRuleConditionType = Object.freeze({
    [LESS]: 0,
    [EQUAL_OR_LESS]: 1,
    [EQUAL]: 2,
    [EQUAL_OR_MORE]: 3,
    [MORE]: 4,
});

export const BreakRuleConditionTypeNames = enumToEnumNames(BreakRuleConditionType);

export default BreakRuleConditionType;
